import * as React from "react";
import type { SVGProps } from "react";

interface OwnGoalProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const OwnGoal = ({ cancelled = false, ...props }: OwnGoalProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1.6 2.15)">
        <ellipse
          cx={9.42}
          cy={8.94}
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={1.72}
          rx={8.92}
          ry={8.88}
        />
        <ellipse
          cx={9.42}
          cy={8.94}
          stroke="#000"
          strokeWidth={1.17}
          rx={8.65}
          ry={8.6}
        />
      </g>
      <path
        fill="#000"
        d="m8.94 9.1 3.68-.5 1.74 3.31-2.68 2.6-3.4-1.72zM3.76 6.9c.44-.86.83-1.46 1.16-1.79.34-.32.94-.7 1.82-1.13l1.66.76L7.32 7.6l-2.9 1zm15.98 3.97a25 25 0 0 1-.19 1.99 6.9 6.9 0 0 1-.77 1.95l-2.07.17-.47-2.69 1.48-3.09zm-5.1 8.03c-.92.42-1.61.64-2.08.68-.47.03-1.21.03-2.23 0l-1.3-1.75 3.19-1.42 2.61.46zM4.2 16.53a4.2 4.2 0 0 1-1.11-1.66c-.12-.45-.22-.97-.3-1.55l1.18-2.39 2.09 2.48.26 3.3-2.11-.18Zm8.72-13.4c.74.08 1.33.22 1.76.4.43.19 1 .6 1.7 1.24l.16 1.66-3.27-.14-2.48-2.11z"
      />
      <g transform="translate(9 9)">
        <circle
          cx={7}
          cy={7}
          r={7.38}
          fill="#FF1212"
          stroke="#FFF"
          strokeWidth={0.75}
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M7 9.35c.27 0 .5.1.7.29s.3.42.3.7-.1.51-.3.7c-.2.2-.43.3-.7.3a.96.96 0 0 1-.7-.3.96.96 0 0 1-.3-.7c0-.27.1-.51.3-.7.18-.2.42-.29.7-.29m-.02-6.3c.57 0 .86.3.84.84l-.16 3.98c-.03.53-.25.81-.65.81-.42 0-.64-.28-.67-.8l-.16-3.99c-.02-.55.26-.84.8-.84"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default OwnGoal;
